import { useFavoriteStore, useRecentlyVisitedStore, useUiStateStore } from "@/stores";

export default defineNuxtPlugin({
  name: "init-states",
  async setup(nuxtApp) {
    nuxtApp.hook("app:created", async () => {
      const uiStateStore = useUiStateStore();
      const favoriteStore = useFavoriteStore();
      const recentlyVisitedStore = useRecentlyVisitedStore();
      await uiStateStore.initState();
      await favoriteStore.initState();
      await recentlyVisitedStore.initState();
    });
  }
});
